import { ThirdPartyConfigDto } from "@repo/api/third-party-config";
import { IconArrowsRightLeft } from "@tabler/icons-react";

type Props = {
  thirdPartyConfig: ThirdPartyConfigDto;
  isExistingVideo?: boolean;
};

export default function ThirdPartyVideoDialogHeader({
  thirdPartyConfig,
  isExistingVideo,
}: Props) {
  let title = "Create video from listing images";
  let description = `Amplifiles gets the images from ${thirdPartyConfig.displayName} automatically`;

  if (isExistingVideo) {
    title = "Edit existing video";
    description = `Make changes to your existing video and export it again`;
  }

  return (
    <div className="mt-28 flex w-full flex-col items-center justify-center px-4 sm:mt-38">
      <div className="flex items-center justify-center gap-10">
        <img
          src={thirdPartyConfig.squareLogoSrc}
          alt={thirdPartyConfig.displayName}
          className="h-13 w-13 object-contain object-center sm:h-15 sm:w-15"
        />
        <IconArrowsRightLeft
          className="h-5 w-5 text-text-secondary"
          stroke={1.5}
        />
        <img
          src="/AmplifilesLogo2.png"
          alt="Amplifiles Logo"
          className=":w-15 h-13 w-13 object-contain object-center sm:h-15"
        />
      </div>
      <h1 className="mt-8 text-center text-xl font-bold sm:text-2xl">
        {title}
      </h1>
      <p className="mt-1 text-center text-base text-text-secondary">
        {description}
      </p>
    </div>
  );
}
